<template>
  <fwb-navbar
    solid
    class="sticky top-0 z-40 shadow
           !bg-slate-800 !text-gray-100
           dark:!bg-slate-900 dark:!text-gray-100"
  >
    <!-- Brand -->
    <router-link to="/" class="flex items-center">
      <fwb-navbar-logo
        alt="logo"
        image-url="https://cdn-icons-png.flaticon.com/512/1388/1388393.png"
      >
        Controle de Entregas
      </fwb-navbar-logo>
    </router-link>

    <!-- Primary nav -->
    <fwb-navbar-collapse class="ml-4">
      <router-link
        to="/"
        class="px-3 py-2 rounded-md text-gray-200 hover:text-white hover:bg-slate-700/60"
      >Formulário</router-link>
      <router-link
        to="/registros"
        class="px-3 py-2 rounded-md text-gray-200 hover:text-white hover:bg-slate-700/60"
      >Registros</router-link>
      <router-link
  to="/ajuda"
  class="px-3 py-2 rounded-md text-gray-200 hover:text-white hover:bg-slate-700/60"
>
  Ajuda
</router-link>
<router-link
  v-if="isAuthed && canSeeAdminRegistros"
  to="/admin/registros"
  class="px-3 py-2 rounded-md text-gray-200 hover:text-white hover:bg-slate-700/60"
>
  Visão Exploratória
</router-link>
<router-link
  v-if="isAuthed && canSeeAdminRegistros"
  to="/admin/visao-geral"
  class="px-3 py-2 rounded-md text-gray-200 hover:text-white hover:bg-slate-700/60"
>
  Visão Geral
</router-link>
<!-- Botão para gerenciar adm - Apagar se necessário-->
<router-link
  v-if="isAuthed && canSeeAdminRegistros"
  to="/admin/usuarios"
  class="px-3 py-2 rounded-md text-gray-200 hover:text-white hover:bg-slate-700/60"
>
  Gerenciar administradores
</router-link>

<!-- Botão para atividades dos adm - Apagar se necessário-->
<router-link
  v-if="isAuthed && canSeeAdminRegistros"
  to="/admin/atividades"
  class="px-3 py-2 rounded-md text-gray-200 hover:text-white hover:bg-slate-700/60"
>
  Atividades administradores
</router-link>
    </fwb-navbar-collapse>

    <!-- Right side tools -->
    <div class="ml-auto flex items-center gap-3 pr-3">
      <span class="hidden md:inline text-sm text-gray-200">
        {{ today }}
      </span>

      <!-- Dark mode toggle -->
      <button
        @click="toggleDarkMode"
        class="p-2 rounded-lg hover:bg-slate-700/60"
        :title="isDark ? 'Tema claro' : 'Tema escuro'"
        aria-label="Alternar tema"
      >
        <!-- Moon -->
        <svg v-if="!isDark" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5"
             fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M20.354 15.354A9 9 0 118.646 3.646a7 7 0 1011.708 11.708z"/>
        </svg>
        <!-- Sun -->
        <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-5 w-5"
             fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 3v2m0 14v2m7.07-11.07l-1.41 1.41M6.34 17.66l-1.41 1.41M21 12h-2M5 12H3m14.66 5.66l-1.41-1.41M7.76 7.76L6.34 6.34M12 8a4 4 0 100 8 4 4 0 000-8z"/>
        </svg>
      </button>

      <!-- New entry (hide if not authed) -->
      <button
        v-if="isAuthed"
        @click="$router.push('/')"
        class="hidden sm:inline px-3 py-2 text-sm rounded-lg bg-emerald-600 text-white hover:bg-emerald-700"
      >
        Novo Registro
      </button>

      <!-- Avatar -->
      <button
        v-if="isAuthed"
        @click="$router.push('/perfil')"
        class="w-8 h-8 rounded-full bg-emerald-100 text-emerald-900 flex items-center justify-center font-semibold hover:ring-emerald-400"
        :title="userName"
      >
        {{ initials }}
    </button>

      <!-- Auth action -->
      <router-link
        v-if="!isAuthed"
        to="/login"
        class="px-3 py-2 text-sm rounded-lg bg-slate-700/60 hover:bg-slate-700 text-white"
      >Entrar</router-link>

      <button
        v-else
        @click="logout"
        class="px-3 py-2 text-sm rounded-lg bg-slate-700/60 hover:bg-slate-700 text-white"
      >Sair</button>
    </div>
    
  </fwb-navbar>
</template>

<script>
import axios from 'axios'
import { FwbNavbar, FwbNavbarLogo, FwbNavbarCollapse } from 'flowbite-vue';

export default {
  name: 'AppHeader',
  components: { FwbNavbar, FwbNavbarLogo, FwbNavbarCollapse },
  data() {
    return {
      isDark: false,
      today: '',
      userName: 'Visitante',
      isAuthed: !!localStorage.getItem('token'),
    };
  },
  computed: {
  initials() {
    const parts = this.userName.trim().split(/\s+/);
    return parts.slice(0, 2).map(p => p[0]?.toUpperCase() || '').join('');
  },

  userIsAdmin() {
    try {
      const raw = localStorage.getItem('user');
      if (!raw) return false;
      const u = JSON.parse(raw);
      return !!u?.admin;
    } catch { return false; }
  },

  userIsManager() {
    try {
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      return !!u?.manager;
    } catch { return false; }
  },

  canSeeAdminRegistros() {
    return this.userIsAdmin || this.userIsManager;
  },
},

  created() {
    this.today = new Date().toLocaleDateString('pt-BR', {
      weekday: 'short', year: 'numeric', month: 'short', day: '2-digit',
    });
    this.loadUser();
  },
  mounted() {
    const saved = localStorage.getItem('theme');
    const prefersDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches;
    this.isDark = saved ? saved === 'dark' : !!prefersDark;
    this.applyTheme();

    // sync auth state across tabs
    window.addEventListener('storage', this.syncAuth);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.syncAuth);
  },
  methods: {
    loadUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return;
    const u = JSON.parse(raw);
    if (u?.name) this.userName = u.name;
  } catch (e) {
    // Malformed JSON in localStorage; reset to a safe default
    localStorage.removeItem('user');
    this.userName = 'Visitante';
  }
},

    syncAuth() {
      this.isAuthed = !!localStorage.getItem('token');
      this.loadUser();
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      delete axios.defaults.headers.common.Authorization;
      this.isAuthed = false;
      this.userName = 'Visitante';
      this.$router.replace('/login');
    },
    toggleDarkMode() {
      this.isDark = !this.isDark;
      localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
      this.applyTheme();
    },
    applyTheme() {
      const root = document.documentElement;
      if (this.isDark) root.classList.add('dark');
      else root.classList.remove('dark');
    },
  },
};
</script>

<style scoped>
:deep(nav) { min-height: 3.5rem; }

:deep(a.router-link-active) {
  color: #ffffff;
  background-color: rgb(30 41 59 / 0.6);
  border-bottom: 2px solid rgb(52 211 153);
}
</style>
